import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import { useNavigate } from "react-router-dom";
import "./surveyForm.css";

function SuccessMessage() {
  const navigate = useNavigate();

  const handleNavigate = (e) => {
    navigate("/MFISurveyForm");
  };

  return (
    <div className="thankyou-container">
      <CheckCircleOutlineOutlinedIcon
        className="thankyou-icon"
        style={{ fontSize: "4rem" }}
      />
      <h2>Survey Submitted Successfully!</h2>
      <p>
        We have received your survey responses. Thank you for helping us
        strengthen our service delivery and decision-making.
      </p>
      <button onClick={handleNavigate}>
        Back Home <i class="bi bi-arrow-right"></i>
      </button>
    </div>
  );
}

export default SuccessMessage;
